import React from 'react';
import PoweredByEaco from './PoweredByEaco';

const NotFoundView: React.FC = () => (
  <div className="flex min-h-screen flex-col bg-background">
    <div className="flex flex-1 items-center justify-center p-6 text-center">
      <div className="space-y-2">
        <h1 className="text-2xl font-semibold">Form not found</h1>
        <p className="text-sm text-muted-foreground">
          The link you followed may be expired, private, or incorrect.
        </p>
      </div>
    </div>
    <PoweredByEaco />
  </div>
);

export default NotFoundView;
